import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-revert',
  templateUrl: './icon-revert.component.html',
  styleUrls: ['./icon-revert.component.scss']
})
export class IconRevertComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
